import { Button } from "@/components/ui/button";

import aldLogo from "/wpx-logo.svg";

const GlobalErrorPage = (): JSX.Element => {
  const handleTryAgain = (): void => {
    window.location.reload();
  };

  return (
    <div className='flex items-center justify-center min-h-screen error-boundary'>
      <div className='text-center'>
        <img
          src={aldLogo}
          className='flex-shrink-0 object-contain h-8 mx-auto rounded-md select-none drag-none'
          alt='logo'
        />
        <h1 className='mt-6 mb-4 text-4xl font-medium text-gray-800'>
          Oops!! Something went wrong!
        </h1>
        <p className='mb-8 text-lg text-gray-600'>
          We have been notified of the error and will fix it as soon as
          possible.
          <br /> Meanwhile, You can try refreshing the page, if the error
          persists, please contact support
        </p>
        <Button onClick={handleTryAgain}>Try Again</Button>
      </div>
    </div>
  );
};

export default GlobalErrorPage;
